import { useCallback, useState } from 'react';
import './App.css';
import StatsDisplay from './components/StatsDisplay';
import CardDisplay from './components/CardDisplay';
import Stats from './Stats';
import Card from './Card';

function App() {
  const [stats, setStats] = useState(Stats.makeInitial());
  const [round, setRound] = useState(0);
  const [numCards, setNumCards] = useState(3);
  const [cards, setCards] = useState([new Card(0), new Card(0), new Card(0)])

  const runCard = useCallback((card) => {
    let newNumCards = numCards;
    const decCards = function() {
      --newNumCards;
      setNumCards(newNumCards);
    }

    card.runCard(stats, decCards);
    const curr = round + 1;
    setRound(curr);
    const newcards = [];
    for (let i = 0; i < newNumCards; ++i) {
      newcards.push(new Card(curr));
    }
    setCards(newcards);
    setStats(stats);
  }, [numCards, setNumCards, setCards, stats, setStats, round, setRound]);

  const cardDisp = [];
  for (let i = 0; i < cards.length; ++i) {
    cardDisp.push(<CardDisplay key={i} card={cards[i]} runCard={runCard} />)
  }

  return (
    <div className="App">
      <StatsDisplay stats={stats} round={round}/>
      {cardDisp}
    </div>
  );
}

export default App;
